import { render, staticRenderFns } from "./ComplaintTypeDelete.vue?vue&type=template&id=5dac317e&"
import script from "./ComplaintTypeDelete.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports